module.exports = __webpack_public_path__ + "img/9788925563909.446a318d.jpg";